import { isPublicId } from '@idc-forms/id'
import { FEATURES } from '@/shared/config/features'

/**
 * Qué API atiende cada comando de reserva.
 *
 * Vive aparte del hook a propósito: son funciones PURAS y el hook arrastra el proveedor de sesión.
 * Separarlas las hace probables sin montar medio árbol de React, y deja claro que la decisión no
 * depende de nada de la pantalla.
 *
 * Son DOS y no una porque las dos identidades entran en momentos distintos:
 *
 * - **Crear** sólo necesita el `prp_` del inmueble: todavía no hay reserva a la que apuntar.
 * - **Liberar, autorizar y rechazar** necesitan el `rsv_` de la reserva viva. Una reserva creada
 *   por v1 no lo tiene, así que sus comandos siguen en v1 aunque el flag esté prendido — y eso es
 *   lo correcto: v2 no ofrece forma de resolver un `_id`, a propósito. Mandárselo igual no da un
 *   error entendible, da un rechazo del pipe de id público sobre una acción que antes funcionaba.
 *
 * Cuando muera el flag y no queden reservas v1 vivas, las dos son siempre `true` y los caminos
 * legacy se borran.
 */

export function reservationCreateSpeaksV2(propertyPublicId: string | undefined): boolean {
  if (!FEATURES.webAuthV2) return false
  return isPublicId(propertyPublicId, 'prp')
}

export function reservationCommandsSpeakV2(
  reservationPublicId: string | null | undefined
): boolean {
  if (!FEATURES.webAuthV2) return false
  return isPublicId(reservationPublicId, 'rsv')
}

/** Las DOS direcciones de una reserva. Quien llama trae las dos y el despachador elige. */
export type Reservation = {
  /** El `_id` de Mongo — lo que v1 sabe recibir. */
  id: string
  /** El `rsv_`, cuando la reserva nació en v2. */
  publicId?: string | null
}
